<script>
  import {onMount} from 'svelte';
  import storeTrabajadores from '../Stores/resumen-trabajadores-store';
  import storeCalendario from '../Stores/calendario-store';
  import {diasIncorrectos} from '../Api/marcajes';
  import {nombreCompleto} from '../Modelos/Trabajador';

  import {url} from '@sveltech/routify';

  import Caja from "../Components/UI/Caja.svelte";
  import ListadoDeTrabajadores from "../Components/Trabajadores/Listado/index.svelte";
  import Loading from "../Components/UI/Loading.svelte";

  import Titulo from "../Components/UI/Titulo.svelte";
  import Subtitulo from "../Components/UI/Subtitulo.svelte";

  import {addMonths, format, parse, startOfMonth} from 'date-fns';
  import {es} from 'date-fns/locale';
  import Mes from "../Components/Calendario/Mes.svelte";
  import Icono from "../Components/UI/Icono.svelte";
  import CampoDeTexto from "../Components/UI/CampoDeTexto.svelte";

  const fecha = startOfMonth(new Date());
  const meses = [...Array(3).keys()].map(x => addMonths(fecha, x));

  let dias = diasIncorrectos();

  onMount(() => {
    storeTrabajadores.cargar();
    storeCalendario.cargarDeEmpresa(fecha.getFullYear());
  });

  let filtro = '';
  $: listadoFiltrado = $storeTrabajadores.listado.filter(x => {
    return filtro === '' || nombreCompleto(x.trabajador).toLowerCase().indexOf(filtro.toLowerCase()) >= 0;
  });
</script>

<svelte:head>
    <title>Panel de control</title>
</svelte:head>

<Titulo>Panel de control</Titulo>

<div class="contenido">
    <div class="trabajadores">
        <Caja alturaMaxima="300px">
            <div slot="titulo" style="display:flex; justify-content: space-between">
                <Subtitulo>Trabajadores</Subtitulo>
                <div class="filtro">
                    <CampoDeTexto icono="search" value={filtro}
                                  on:input={({target}) => filtro = target.value}/>
                </div>
            </div>

            {#if $storeTrabajadores.cargando}
                <Loading/>
            {:else if $storeTrabajadores.error}
                <p>Error cargando trabajadores</p>
            {/if}

            {#if $storeTrabajadores.listado}
                <ListadoDeTrabajadores trabajadores={listadoFiltrado}/>
            {/if}
        </Caja>
    </div>

    <div class="dias-incorrectos">
        <Caja alturaMaxima="338px">
            <div slot="titulo">
                <div class="aviso">
                    <Subtitulo>
                        <i class="material-icons">warning</i>
                        Días con error
                    </Subtitulo>
                </div>
            </div>

            {#await dias}
                <Loading/>
            {:then lista}
                {#each lista as dia}
                    <div class="dia">
                        <div class="dia-nombre">
                            <a href={$url(`/trabajadores/${dia.trabajador.id}/marcajes/${dia.fecha.split('-').reverse().join('-')}`)}>
                                {nombreCompleto(dia.trabajador)}
                            </a>
                        </div>
                        <div class="dia-cuenta">
                            <a href={$url(`/trabajadores/${dia.trabajador.id}/marcajes/${dia.fecha.split('-').reverse().join('-')}`)}>
                                {format(parse(dia.fecha, 'yyyy-MM-dd', new Date()), "d 'de' LLLL", {locale: es})}
                            </a>
                        </div>
                    </div>
                {:else}
                    <div class="sin-errores">
                        <p>No hay ninguna incidencia</p>
                        <Icono tamano={60}>check</Icono>
                    </div>
                {/each}
            {:catch error}
                <p>Error cargando días</p>
            {/await}
        </Caja>
    </div>

    <div class="calendario">
        <Caja>
            <div slot="titulo">
                <Subtitulo>Calendario de la empresa</Subtitulo>
            </div>

            {#if $storeCalendario.cargando}
                <Loading/>
            {:else if $storeCalendario.error}
                <p>Error cargando calendario</p>
            {/if}

            {#if $storeCalendario.calendario }
                <div class="meses">
                    {#each meses as fecha}
                        <div>
                            <Mes calendario={$storeCalendario.calendario.meses[fecha.getMonth()]}
                                 {fecha} conTitulo/>
                        </div>
                    {/each}
                </div>
            {/if}
        </Caja>
    </div>
</div>


<style>
    .contenido {
        display: grid;
        grid-gap: var(--padding-global);
        grid-template-rows: max-content;
        grid-template-columns: 2fr 1fr;
    }

    .trabajadores {
        grid-column: 1;
        grid-row: 1;
    }

    .dias-incorrectos {
        grid-column: 2;
        grid-row: 1;
        --color-icono: var(--verde);
    }

    .sin-errores {
        text-align: center;
    }

    .calendario {
        grid-column: 1 / 3;
        grid-row: 2;
    }

    .meses {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: var(--padding-global);
    }

    .dia a {
        color: currentColor;
        text-decoration: none;
    }

    .dia {
        display: flex;
        justify-content: space-between;
    }

    .dia:not(:last-child) {
        margin-bottom: 1em;
    }

    .dia-nombre {
        font-weight: 500;
    }

    .material-icons {
        color: red;
        margin-right: .25em;
    }
</style>